import { useState, useEffect } from 'react'

interface MobileDetectionResult {
	isMobile: boolean
	isTouchDevice: boolean
	screenWidth: number
}

/**
 * Hook to detect mobile devices and touch capabilities.
 * - isMobile: true when screen width <= 768px
 * - isTouchDevice: true when device supports touch
 * - screenWidth: current window width
 */
export const useMobileDetection = (): MobileDetectionResult => {
	const [state, setState] = useState<MobileDetectionResult>(() => ({
		isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
		isTouchDevice: typeof window !== 'undefined'
			? 'ontouchstart' in window || navigator.maxTouchPoints > 0
			: false,
		screenWidth: typeof window !== 'undefined' ? window.innerWidth : 1024
	}))

	useEffect(() => {
		const handleResize = () => {
			setState(prev => ({
				...prev,
				isMobile: window.innerWidth <= 768,
				screenWidth: window.innerWidth
			}))
		}

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return state
}

export default useMobileDetection
